import { Components, Theme } from '@mui/material/styles';

export const MuiTypography: Components<Omit<Theme, 'components'>>['MuiTypography'] = {
  styleOverrides: {
    root: {
      color: 'currentcolor',
    },
  },
};
